module.exports = function (e) {
  var t = {};
  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }
  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 2);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("tui-calendar");
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "default", function () {
    return P;
  });
  var n = r(0),
    o = r.n(n),
    i = r(1),
    u = r.n(i);
  function c(e) {
    return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var a = function a(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  };
  function l(e, t) {
    if (e === t) return !0;
    if (e instanceof Function) return e.toString() === t.toString();
    if (e && t && "object" === c(e) && "object" === c(t)) {
      var r;
      if (e.constructor !== t.constructor) return !1;
      if (Array.isArray(e)) {
        if ((r = e.length) !== t.length) return !1;
        for (var n = 0; n < r; n += 1) {
          if (!l(e[n], t[n])) return !1;
        }
        return !0;
      }
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
      var o = Object.keys(e);
      if ((r = o.length) !== Object.keys(t).length) return !1;
      for (var i = 0; i < r; i += 1) {
        var u = o[i];
        if (!a(t, u) || !l(e[u], t[u])) return !1;
      }
      return !0;
    }
    return e != e && t != t;
  }
  function f(e) {
    return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  var s = ["schedules", "view"];
  function p(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function y(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? p(Object(r), !0).forEach(function (t) {
        w(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : p(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  function h(e, t) {
    if (null == e) return {};
    var r,
      n,
      o = function (e, t) {
        if (null == e) return {};
        var r,
          n,
          o = {},
          i = Object.keys(e);
        for (n = 0; n < i.length; n++) {
          r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
        }
        return o;
      }(e, t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }
    return o;
  }
  function b(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function d(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  function v(e, t) {
    return (v = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function O(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var r,
        n = j(e);
      if (t) {
        var o = j(this).constructor;
        r = Reflect.construct(n, arguments, o);
      } else r = n.apply(this, arguments);
      return m(this, r);
    };
  }
  function m(e, t) {
    if (t && ("object" === f(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return g(e);
  }
  function g(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function j(e) {
    return (j = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function w(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }
  var S = ["disableDblClick", "isReadOnly", "month", "scheduleView", "taskView", "theme", "timezones", "week", "template"],
    P = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && v(e, t);
      }(c, e);
      var t,
        r,
        n,
        i = O(c);
      function c() {
        var e;
        b(this, c);
        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
          r[n] = arguments[n];
        }
        return w(g(e = i.call.apply(i, [this].concat(r))), "rootEl", o.a.createRef()), w(g(e), "calendarInst", null), w(g(e), "bindEventHandlers", function (t) {
          Object.keys(t).filter(function (e) {
            return /^on[A-Z][a-zA-Z]+/.test(e);
          }).forEach(function (r) {
            var n = r[2].toLowerCase() + r.slice(3);
            e.calendarInst.off(n), e.calendarInst.on(n, t[r]);
          });
        }), e;
      }
      return t = c, (r = [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
            t = e.schedules,
            r = void 0 === t ? [] : t,
            n = e.view,
            o = h(e, s),
            i = this.getRootElement();
          this.calendarInst = new u.a(i, y(y({}, o), {}, {
            defaultView: n
          })), i.style.height = this.props.height, this.setSchedules(r), this.bindEventHandlers(o);
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value(e) {
          var t = this,
            r = this.props,
            n = r.calendars,
            o = r.height,
            i = r.schedules,
            u = r.theme,
            c = r.view;
          return l(o, e.height) || (this.getRootElement().style.height = e.height), l(n, e.calendars) || this.setCalendars(e.calendars), l(i, e.schedules) || (this.calendarInst.clear(), this.setSchedules(e.schedules)), l(u, e.theme) || this.calendarInst.setTheme(this.cloneData(e.theme)), l(c, e.view) || this.calendarInst.changeView(e.view), S.forEach(function (r) {
            l(t.props[r], e[r]) || t.setOptions(r, e[r]);
          }), this.bindEventHandlers(this.props), !1;
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.calendarInst.destroy();
        }
      }, {
        key: "cloneData",
        value: function value(e) {
          return JSON.parse(JSON.stringify(e));
        }
      }, {
        key: "setCalendars",
        value: function value(e) {
          e && e.length && this.calendarInst.setCalendars(e);
        }
      }, {
        key: "setSchedules",
        value: function value(e) {
          if (e && e.length) {
            var t = this.cloneData(e);
            this.calendarInst.createSchedules(t);
          }
        }
      }, {
        key: "setOptions",
        value: function value(e, t) {
          this.calendarInst.setOptions(w({}, e, t), !0);
        }
      }, {
        key: "getInstance",
        value: function value() {
          return this.calendarInst;
        }
      }, {
        key: "getRootElement",
        value: function value() {
          return this.rootEl.current;
        }
      }, {
        key: "render",
        value: function value() {
          return o.a.createElement("div", {
            className: "tui-calendar-react-root",
            ref: this.rootEl
          });
        }
      }]) && d(t.prototype, r), n && d(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), c;
    }(o.a.Component);
  w(P, "defaultProps", {
    height: "800px",
    view: "week"
  });
}]);